import { Anchor, MapPin, FileText, CreditCard } from "lucide-react";
import { ZipAutoFillInput } from "../../components/ZipAutoFillInput";

export default function QuoteForm({ quoteData, setQuoteData, services, leadSources }) {
    const handlePaymentMethodChange = (method) => {
        if (method === "cash") {
            setQuoteData(prev => ({
                ...prev,
                payment_method: "cash",
                fees: [],
                quote_fuel: prev.quote_fuel || ""
            }));
        } else {
            setQuoteData(prev => ({
                ...prev,
                payment_method: "stripe",
                fees: prev.fees || [],
                quote_fuel: ""
            }));
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-lg font-bold text-gray-900 mb-1">Quote Details</h2>
                <p className="text-xs text-gray-600 mb-5">Provide Vessel and service information</p>

                <div className="space-y-6">
                    <div>
                        <h3 className="text-sm font-bold text-gray-900 mb-4 flex items-center gap-1.5">
                            <Anchor className="w-4 h-4" />
                            Vessel Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Vessel Type *
                                </label>
                                <select
                                    value={quoteData.boat_type}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, boat_type: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                    required
                                >
                                    <option value="">Select vessel type</option>
                                    <option value="Power Boat">Power Boat</option>
                                    <option value="Sailboat">Sailboat</option>
                                    <option value="Yacht">Yacht</option>
                                    <option value="Catamaran">Catamaran</option>
                                    <option value="Fishing Boat">Fishing Boat</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Vessel Year
                                </label>
                                <input
                                    type="text"
                                    placeholder="e.g., 2020"
                                    value={quoteData.boat_year}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, boat_year: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Vessel Manufacturer *
                                </label>
                                <input
                                    type="text"
                                    placeholder="e.g., Beneteau"
                                    value={quoteData.boat_make}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, boat_make: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Vessel Length
                                </label>
                                <input
                                    type="text"
                                    placeholder="e.g., 45 feet"
                                    value={quoteData.boat_length}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, boat_length: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                />
                            </div>
                        </div>
                    </div>

                    <hr className="border-gray-200" />

                    <div>
                        <h3 className="text-sm font-bold text-gray-900 mb-4 flex items-center gap-1.5">
                            <MapPin className="w-4 h-4" />
                            Location Details
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Zip Code
                                </label>
                                <ZipAutoFillInput
                                    zip={quoteData.zip_code}
                                    onZipChange={(zip) => setQuoteData(prev => ({ ...prev, zip_code: zip || "" }))}
                                    onAddressResolved={({ city, state, country }) => {
                                        const parts = [city, state, country].filter(Boolean);
                                        if (parts.length > 0) {
                                            setQuoteData(prev => ({ ...prev, boat_location: parts.join(', ') }));
                                        }
                                    }}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Vessel Location
                                </label>
                                <input
                                    type="text"
                                    placeholder="e.g., Miami Marina"
                                    value={quoteData.boat_location}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, boat_location: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                />
                            </div>

                            <div className="md:col-span-2">
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={quoteData.is_boat_in_water}
                                        onChange={(e) => setQuoteData(prev => ({ ...prev, is_boat_in_water: e.target.checked }))}
                                        className="w-4 h-4 text-blue-500 rounded focus:ring-blue-500"
                                    />
                                    <span className="text-xs font-medium text-gray-700">Is boat in water?</span>
                                </label>
                            </div>

                            {quoteData.is_boat_in_water && (
                                <>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                            Dock
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="e.g., A"
                                            value={quoteData.dock}
                                            onChange={(e) => setQuoteData(prev => ({ ...prev, dock: e.target.value }))}
                                            className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                            Slip Number
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="e.g., 12"
                                            value={quoteData.slip_number}
                                            onChange={(e) => setQuoteData(prev => ({ ...prev, slip_number: e.target.value }))}
                                            className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <hr className="border-gray-200" />

                    <div>
                        <h3 className="text-sm font-bold text-gray-900 mb-4 flex items-center gap-1.5">
                            <FileText className="w-4 h-4" />
                            Service Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Survey Type *
                                </label>
                                <select
                                    value={quoteData.service_id}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, service_id: e.target.value ? Number(e.target.value) : "" }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                    required
                                    disabled={!services || services.length === 0}
                                >
                                    <option value="">
                                        {!services || services.length === 0 ? "Loading services..." : "Select service"}
                                    </option>
                                    {services && services.map(service => (
                                        <option key={service.id} value={service.id}>{service.name}</option>
                                    ))}
                                </select>
                            </div>

                            {leadSources.length > 0 && (
                                <div>
                                    <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                        Lead Source
                                    </label>
                                    <select
                                        value={quoteData.lead_source_id}
                                        onChange={(e) => setQuoteData(prev => ({ ...prev, lead_source_id: e.target.value }))}
                                        className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                    >
                                        <option value="">Select Lead Source</option>
                                        {leadSources.map(source => (
                                            <option key={source.id} value={source.id}>{source.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div className="md:col-span-2">
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Message / Notes
                                </label>
                                <textarea
                                    placeholder="Add any additional information or special requirements..."
                                    value={quoteData.message}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, message: e.target.value }))}
                                    rows={4}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs resize-none"
                                />
                            </div>
                        </div>
                    </div>

                    <hr className="border-gray-200" />

                    <div>
                        <h3 className="text-sm font-bold text-gray-900 mb-4 flex items-center gap-1.5">
                            <CreditCard className="w-4 h-4" />
                            Payment Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Payment Method
                                </label>
                                <select
                                    value={quoteData.payment_method || ""}
                                    onChange={(e) => handlePaymentMethodChange(e.target.value)}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                >
                                    <option value="">Select payment method</option>
                                    <option value="stripe">Visa</option>
                                    <option value="cash">Cash</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                    Amount ($)
                                </label>
                                <input
                                    type="number"
                                    placeholder="e.g., 2500.00"
                                    value={quoteData.amount}
                                    onChange={(e) => setQuoteData(prev => ({ ...prev, amount: e.target.value }))}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                    min="0"
                                    step="0.01"
                                />
                            </div>

                            {(quoteData.payment_method === "stripe" || quoteData.payment_method === "cash") && (
                                <div className="md:col-span-2">
                                    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 space-y-4">
                                        {quoteData.payment_method === "stripe" ? (
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                    Fuel Surcharge ($)
                                                </label>
                                                <input
                                                    type="number"
                                                    placeholder="e.g., 200.00"
                                                    value={quoteData.fees && quoteData.fees.length > 0 && quoteData.fees[0] ? (quoteData.fees[0].value || "") : ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value) {
                                                            setQuoteData(prev => ({
                                                                ...prev,
                                                                fees: [{ value: value }]
                                                            }));
                                                        } else {
                                                            setQuoteData(prev => ({
                                                                ...prev,
                                                                fees: []
                                                            }));
                                                        }
                                                    }}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                    Fuel Surcharge ($)
                                                </label>
                                                <input
                                                    type="number"
                                                    placeholder="e.g., 200.00"
                                                    value={quoteData.quote_fuel || ""}
                                                    onChange={(e) => {
                                                        setQuoteData(prev => ({
                                                            ...prev,
                                                            quote_fuel: e.target.value
                                                        }));
                                                    }}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </div>
                                        )}

                                        <div>
                                            <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                Report Generation Fees ($)
                                            </label>
                                            <input
                                                type="number"
                                                placeholder="e.g., 50.00"
                                                value={quoteData.report_generation_fees || ""}
                                                onChange={(e) => {
                                                    setQuoteData(prev => ({
                                                        ...prev,
                                                        report_generation_fees: e.target.value
                                                    }));
                                                }}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                                min="0"
                                                step="0.01"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                Estimated Days
                                            </label>
                                            <input
                                                type="number"
                                                placeholder="e.g., 3"
                                                value={quoteData.estimated_days || ""}
                                                onChange={(e) => {
                                                    setQuoteData(prev => ({
                                                        ...prev,
                                                        estimated_days: e.target.value
                                                    }));
                                                }}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                                min="1"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                Note *
                                            </label>
                                            <textarea
                                                placeholder="This is the offer description..."
                                                value={quoteData.offer_description || ""}
                                                onChange={(e) => {
                                                    setQuoteData(prev => ({
                                                        ...prev,
                                                        offer_description: e.target.value
                                                    }));
                                                }}
                                                rows={3}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs resize-none"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                                Agreement Type *
                                            </label>
                                            <select
                                                value={quoteData.agreement_type || ""}
                                                onChange={(e) => {
                                                    setQuoteData(prev => ({
                                                        ...prev,
                                                        agreement_type: e.target.value
                                                    }));
                                                }}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 text-xs"
                                                required
                                            >
                                                <option value="">Select agreement type</option>
                                                <option value="text">Text</option>
                                                <option value="signature">Signature</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
